interface GatewayStationSummary{
  site_id: string;
  site_description: string;
}

export const getStationLabel = (station: GatewayStationSummary) => `${station && station.site_id ? station.site_id.trim() : ''} - ${station && station.site_description ? station.site_description.trim() : ''}`;

export default GatewayStationSummary;
